import {TimeSeriesChart, TimeSeriesChartProps} from "../../../lineitems-store/TimeSeriesChart";
import React from "react";
import {formatValueWithValueType} from "./formatting";
export function WSTimeSeriesChart(props: TimeSeriesChartProps){
    const timeSeriesChartProps: TimeSeriesChartProps = {...props, options: {...(props?.options ?? {}), customValueFormatter: formatValueWithValueType
    }}
    return <TimeSeriesChart {...timeSeriesChartProps} />
}